import { Modal, Button } from 'react-bootstrap';
import { getLoginUrl, useSessionExpired } from '../services/sessionExpiry';

const SessionExpiredModal = () => {
  const expired = useSessionExpired();

  return (
    <Modal
      show={expired}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="session-expired-modal"
    >
      <Modal.Header>
        <Modal.Title>Your session has expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        For your security, you need to sign in again to continue. Any chat that is in progress
        will start fresh after you sign in.
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-microsoft" onClick={() => { window.location.href = getLoginUrl(); }}>
          Sign in
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiredModal;
